import { createSlice } from "@reduxjs/toolkit";
import { FaWarehouse } from "react-icons/fa";

const userSlice = createSlice({
  name: "user",
  initialState: {
    registerMessage: "",
    showDropdown: false,
    currentUser: {},
    userPermissions: {},
    mainSection:  [
      {
        permission:true,
        id: "admin",
        title: "Staff & Groups",
        icon: (
          <svg
            width="21"
            height="11"
            viewBox="0 0 21 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.7474 10.75H14.8741C14.8741 9.392 14.9266 9.19687 14.1041 9.00612C12.8459 8.71562 11.6567 8.44175 11.2227 7.49325C11.0653 7.14675 10.9594 6.57625 11.3584 5.82463C12.2517 4.13675 12.4757 2.6895 11.9726 1.85388C11.3846 0.87825 9.604 0.873875 9.01075 1.86875C8.50675 2.71575 8.73425 4.15513 9.63462 5.81675C10.0415 6.56575 9.93913 7.138 9.78162 7.48625C9.35287 8.43913 8.17513 8.71125 6.92737 8.99825C6.06812 9.19688 6.12238 9.37887 6.12238 10.75H5.25175L5.25 10.2049C5.25 9.10325 5.3375 8.468 6.6395 8.167C8.11125 7.82663 9.5655 7.523 8.86637 6.23412C6.79613 2.41475 8.27488 0.25 10.4983 0.25C12.6788 0.25 14.1969 2.33512 12.1319 6.23412C11.4537 7.51512 12.8529 7.81963 14.3587 8.167C15.6625 8.468 15.7491 9.105 15.7491 10.2084L15.7474 10.75ZM19.9561 8.81275C18.8282 8.552 17.7782 8.32362 18.2866 7.36287C19.8354 4.43862 18.6979 2.875 17.0616 2.875C15.9548 2.875 15.0946 3.58987 15.0946 4.90937C15.0946 6.01975 15.5969 6.8125 15.8856 7.46875H16.8026C16.6539 6.8125 15.5199 5.227 16.1324 4.19975C16.4929 3.59425 17.6234 3.59337 17.9821 4.18925C18.3146 4.74137 18.1405 5.77475 17.5149 6.95512C17.1754 7.5965 17.2699 8.0935 17.409 8.39713C17.6759 8.97987 18.2639 9.26075 18.9289 9.45412C20.2475 9.84 20.1259 9.49088 20.1259 10.7491H20.9982L21 10.344C21 9.51712 20.9352 9.0385 19.9561 8.81275ZM0.00175 10.75H0.874125C0.874125 9.49175 0.7525 9.84088 2.07113 9.455C2.737 9.26163 3.325 8.98075 3.591 8.398C3.73013 8.0935 3.82463 7.59737 3.48513 6.956C2.8595 5.77562 2.68537 4.74225 3.01787 4.19013C3.37662 3.59338 4.50713 3.59425 4.86763 4.20063C5.48012 5.22875 4.34613 6.81338 4.19737 7.46963H5.11437C5.40312 6.81338 5.90538 6.02063 5.90538 4.91025C5.90625 3.58988 5.04612 2.875 3.93925 2.875C2.303 2.875 1.1655 4.43862 2.71425 7.36287C3.22263 8.3245 2.17263 8.552 1.04475 8.81275C0.06475 9.0385 0 9.51713 0 10.3449L0.00175 10.75Z"
              fill="white"
            />
          </svg>
        ),
    
        path: "/dashboard/management/company-staff",
        exact: true,
      },
      {
        permission: true,
        title: "Statistics",
        icon: (
          <svg
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 1.90625L13.5 2.822L14.787 4.103L10.7738 8.1215L8.523 5.87L3.021 11.3015L4.0785 12.365L8.52 7.9895L10.7633 10.2343L15.849 5.16275L17.0993 6.40775L18 1.90625ZM18 14V15.5H0V0.5H1.5V14H18Z"
              fill="white"
            />
          </svg>
        ),
        path: "/dashboard/management/statistics",
        exact: true,
      },
      {
        permission: true,
        title: "Items",
        icon: (
          <svg
            width="18"
            height="16"
            viewBox="0 0 18 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.113 10.772L6.57975 10.25L4.66575 12.2053L3.5115 11.1163L2.988 11.648L4.6755 13.25L7.113 10.772ZM7.113 7.022L6.57975 6.5L4.66575 8.45525L3.5115 7.36625L2.988 7.898L4.6755 9.5L7.113 7.022ZM7.113 3.272L6.57975 2.75L4.66575 4.70525L3.5115 3.61625L2.988 4.148L4.6755 5.75L7.113 3.272ZM15 11.75H9V12.5H15V11.75ZM15 8H9V8.75H15V8ZM15 4.25H9V5H15V4.25ZM18 0.5H0V15.5H18V0.5ZM17.25 14.75H0.75V1.25H17.25V14.75Z"
              fill="white"
            />
          </svg>
        ),
        path: "/dashboard/management/items",
        exact: true,
      },
      {
        permission: true,
        title: "Schedule",
        icon: (
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9 1.5C13.1355 1.5 16.5 4.8645 16.5 9C16.5 13.1355 13.1355 16.5 9 16.5C4.8645 16.5 1.5 13.1355 1.5 9C1.5 4.8645 4.8645 1.5 9 1.5ZM9 0C4.02975 0 0 4.02975 0 9C0 13.9703 4.02975 18 9 18C13.9703 18 18 13.9703 18 9C18 4.02975 13.9703 0 9 0ZM13.386 9.34425C13.5375 9.37275 13.5375 9.594 13.3868 9.62325C11.9565 9.894 8.853 10.4565 8.4765 10.4565C7.93725 10.4565 7.50075 10.02 7.50075 9.48075C7.50075 9.09675 8.07825 5.3955 8.3445 3.897C8.37 3.753 8.5785 3.76125 8.60175 3.9075L9.3405 8.586L13.386 9.34425Z"
              fill="white"
            />
          </svg>
        ),
    
        path: "/dashboard/management/scheduler-dashboard",
        exact: true,
      },
      {
        permission: true,
        title: "Goods in/out",
        path: "/dashboard/management/goods-management",
        exact: true,
        icon: (
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.2508 4.5495V13.5983L9 18L0.75 13.5983V4.5L9 0L17.2508 4.5495ZM1.5 13.1483L8.625 16.95V9.0225L1.5 5.313V13.1483ZM16.5008 5.35725L9.375 9.024V16.95L16.5008 13.1483V5.35725ZM12.3608 6.64425L5.21025 2.92125L1.9485 4.701L9.0015 8.373L12.3608 6.64425ZM6.00375 2.4885L13.1775 6.2235L16.0515 4.7445L8.99775 0.85575L6.00375 2.4885Z"
              fill="white"
            />
          </svg>
        ),
      },
      {
        permission: true,
        title: "Picking & Packing",
        path: "/dashboard/management/pickingDashboard",
        exact: true,
        icon: (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.9212 6.8021C13.8788 6.8021 13.8366 6.78679 13.8012 6.75641L12.3614 5.52447L10.9216 6.75641C10.8608 6.8085 10.7802 6.81695 10.7122 6.77788C10.6444 6.73927 10.6016 6.65999 10.6016 6.57363V1.22847C10.6016 1.10236 10.691 1 10.8016 1H13.9212C14.0318 1 14.1212 1.10236 14.1212 1.22847V6.57363C14.1212 6.65999 14.0784 6.73927 14.0106 6.77788C13.9822 6.79433 13.9516 6.8021 13.9212 6.8021ZM12.3614 5.01064C12.4036 5.01064 12.4458 5.02571 12.4814 5.05633L13.7212 6.11714V1.45695H11.0016V6.11714L12.2414 5.05633C12.277 5.02594 12.3192 5.01064 12.3614 5.01064Z"
              fill="white"
              stroke="white"
              stroke-width="0.75"
            />
            <path
              d="M8.77911 18.4707C8.56211 18.4707 8.34511 18.4435 8.13371 18.3896L5.80111 17.7953C5.54891 17.7314 5.29011 17.6987 5.03231 17.6987H3.39531C3.28491 17.6987 3.19531 17.5966 3.19531 17.4702V14.2103C3.19531 14.1491 3.21671 14.0906 3.25491 14.0474C3.29311 14.0045 3.34951 13.981 3.39831 13.9819L4.46351 14.0011C4.55831 14.0063 4.64831 13.962 4.72191 13.8886C5.59891 13.0131 6.41031 12.3985 7.74371 12.0392C7.98011 11.9786 8.21311 11.927 8.44831 11.8744C9.23551 11.699 10.0495 11.5178 11.0061 11.0005C11.4125 10.7809 11.7471 10.7883 12.0001 11.0218C12.2021 11.2089 12.3295 11.5178 12.3247 11.8086C12.3209 12.0435 12.2339 12.2457 12.0799 12.3778C11.2137 13.1196 10.5061 13.4779 9.82191 13.8242C9.66791 13.9024 9.51911 13.9775 9.37191 14.0557C10.6557 14.9798 13.3251 14.4372 15.3089 14.0335C15.7507 13.943 16.1823 14.246 16.3135 14.7361C16.4469 15.2328 16.2323 15.7619 15.8143 15.9671L11.2389 18.1746C10.8815 18.3501 10.5021 18.4426 10.1125 18.449L8.82151 18.4705C8.80771 18.4707 8.79331 18.4707 8.77911 18.4707ZM10.1099 18.2207H10.1119H10.1099ZM3.59551 17.2417H5.03251C5.31951 17.2417 5.60751 17.2778 5.88831 17.3493L8.22111 17.9438C8.41591 17.9936 8.61671 18.0176 8.81631 18.0137L10.1073 17.9923C10.4445 17.9868 10.7727 17.9066 11.0829 17.7544L15.6583 15.5469C15.8871 15.4345 16.0049 15.1434 15.9317 14.8702C15.8595 14.6006 15.6215 14.4338 15.3795 14.4836C13.1769 14.9316 10.1599 15.5451 8.85691 14.18C8.80831 14.129 8.78491 14.0543 8.79411 13.9798C8.80311 13.9056 8.84371 13.8409 8.90251 13.8071C9.15471 13.6627 9.40031 13.5384 9.66051 13.4068C10.3243 13.0707 11.0109 12.7232 11.8405 12.0124C11.8951 11.9654 11.9239 11.8938 11.9255 11.8002C11.9281 11.6471 11.8569 11.4769 11.7487 11.3766C11.6693 11.303 11.5231 11.2267 11.1779 11.4134C10.1761 11.9553 9.33711 12.142 8.52571 12.3227C8.29411 12.3743 8.06471 12.4253 7.83411 12.4842C6.57791 12.8226 5.83811 13.3817 4.98571 14.2325C4.83831 14.3799 4.65291 14.4589 4.45931 14.4575L3.59591 14.442V17.2417H3.59551Z"
              fill="white"
              stroke="white"
              stroke-width="0.75"
            />
            <path
              d="M3.591 19H1V13.3578H3.591V19ZM1.4 18.5431H3.191V13.8148H1.4V18.5431Z"
              fill="white"
              stroke="white"
              stroke-width="0.75"
            />
            <path
              d="M18.8052 15.2527H16.1536C16.043 15.2527 15.9536 15.1505 15.9536 15.0242C15.9536 14.8979 16.043 14.7957 16.1536 14.7957H18.6052V1.45695H6.12656V13.1283C6.12656 13.2547 6.03696 13.3568 5.92656 13.3568C5.81616 13.3568 5.72656 13.2547 5.72656 13.1283V1.22847C5.72656 1.10236 5.81616 1 5.92656 1H18.8052C18.9158 1 19.0052 1.10236 19.0052 1.22847V15.0242C19.0052 15.1505 18.9158 15.2527 18.8052 15.2527Z"
              fill="white"
              stroke="white"
              stroke-width="0.75"
            />
          </svg>
        ),
      },
      {
        permission: true,
        title: "Customer",
        icon: (
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M15.4714 17.25H10.5289L10.2649 16.5L0.00341647 16.4895C-0.000333529 16.4857 0.00191647 14.2957 0.000416471 14.1157C-0.00408353 12.6922 -0.00858361 11.4622 2.08842 10.9792L2.44392 10.8982C3.57192 10.6432 4.97442 10.3267 5.23692 9.7485C5.26767 9.6795 5.36292 9.47025 5.12292 9.02775C3.67842 6.36675 3.40317 4.029 4.34667 2.445C4.98867 1.368 6.16167 0.75 7.56342 0.75C8.95392 0.75 10.1187 1.359 10.7584 2.4195C11.7019 3.984 11.4342 6.33 10.0054 9.02475C9.76992 9.47025 9.86592 9.6795 9.89742 9.74925C10.0107 9.996 10.3257 10.1925 10.7412 10.3582L12.2112 7.69725C12.2907 7.56825 12.4257 7.5 12.5629 7.5C12.8839 7.5 13.0834 7.85325 12.9147 8.12775L11.5999 10.5075H14.6224L13.3084 8.12775C13.1397 7.85325 13.3392 7.5 13.6602 7.5C13.7974 7.5 13.9324 7.56825 14.0119 7.69725L15.5637 10.5075H18.0004V12.7447H17.3794C17.3172 12.7447 17.2624 12.7792 17.2354 12.834L15.4714 17.25ZM17.2497 11.2575H9.00042V12.0045C9.29742 12.0465 9.53742 12.231 9.67167 12.507L11.0629 16.5007H14.9622L16.5499 12.5325C16.6909 12.2392 16.9542 12.0487 17.2497 12.0052V11.2575ZM9.54492 10.5075C9.40542 10.3762 9.29292 10.2292 9.21567 10.0612C9.02817 9.65325 9.07092 9.18675 9.34167 8.6745C10.6422 6.2205 10.9174 4.137 10.1157 2.8065C9.60792 1.9635 8.70192 1.5 7.56342 1.5C6.41592 1.5 5.50242 1.97175 4.99167 2.829C4.18842 4.17675 4.46892 6.25125 5.78217 8.67075C6.06042 9.1815 6.10617 9.648 5.92017 10.0575C5.50392 10.9747 4.03242 11.3077 2.60967 11.6295L2.25642 11.7097C0.801416 12.045 0.745916 12.6517 0.751166 14.1127L0.749666 15.75H10.0099L8.99742 12.7935C8.98767 12.7792 8.93292 12.7447 8.87142 12.7447H8.24967V10.5075H9.54492ZM11.9997 12.7792C11.9997 12.5722 11.8317 12.4042 11.6247 12.4042C11.4177 12.4042 11.2497 12.5722 11.2497 12.7792V15.0292C11.2497 15.2362 11.4177 15.4042 11.6247 15.4042C11.8317 15.4042 11.9997 15.2362 11.9997 15.0292V12.7792ZM13.4997 12.7237C13.4997 12.5167 13.3317 12.3487 13.1247 12.3487C12.9177 12.3487 12.7497 12.5167 12.7497 12.7237V14.9737C12.7497 15.1807 12.9177 15.3487 13.1247 15.3487C13.3317 15.3487 13.4997 15.1807 13.4997 14.9737V12.7237ZM14.9974 12.7237C14.9974 12.5167 14.8294 12.3487 14.6224 12.3487C14.4162 12.3487 14.2474 12.5167 14.2474 12.7237V14.9737C14.2474 15.1807 14.4162 15.3487 14.6224 15.3487C14.8294 15.3487 14.9974 15.1807 14.9974 14.9737V12.7237Z"
              fill="white"
            />
          </svg>
        ),
        path: "/dashboard/management/customer-dashboard",
        exact: true,
      },
      {
        permission: true,
        title: "Supplier",
        path: "/dashboard/management/supplier-dashboard",
        exact: true,
        icon: (
          <svg
            width="18"
            height="14"
            viewBox="0 0 18 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.75 6.25V7H9.75V1.75H2.25V1C2.25 0.586 2.586 0.25 3 0.25H10.5C10.914 0.25 11.25 0.586 11.25 1V2.5H14.7502C15.588 2.5 15.9503 2.932 16.2023 3.33025C16.6478 4.03525 17.3542 5.15425 17.784 5.86375C17.925 6.09775 18 6.36625 18 6.64V10C18 10.8167 17.4427 11.5 16.5 11.5H15.75C15.75 12.742 14.742 13.75 13.5 13.75C12.258 13.75 11.25 12.742 11.25 11.5H8.25C8.25 12.742 7.242 13.75 6 13.75C4.758 13.75 3.75 12.742 3.75 11.5H3C2.586 11.5 2.25 11.164 2.25 10.75V6.25H0.75V4.75H6V6.25H3.75ZM6 10.6C6.4965 10.6 6.9 11.0035 6.9 11.5C6.9 11.9965 6.4965 12.4 6 12.4C5.5035 12.4 5.1 11.9965 5.1 11.5C5.1 11.0035 5.5035 10.6 6 10.6ZM13.5 10.6C13.9965 10.6 14.4 11.0035 14.4 11.5C14.4 11.9965 13.9965 12.4 13.5 12.4C13.0035 12.4 12.6 11.9965 12.6 11.5C12.6 11.0035 13.0035 10.6 13.5 10.6ZM11.25 8.5H3.75V10H4.32375C4.7355 9.5395 5.334 9.25 6 9.25C6.666 9.25 7.2645 9.5395 7.67625 10H11.8238C12.2355 9.5395 12.834 9.25 13.5 9.25C14.166 9.25 14.7645 9.5395 15.1763 10H16.5V6.56875L15.2167 4.372C15.0825 4.14175 14.8357 4 14.5695 4H11.25V8.5ZM12 4.75V7H15.75L14.6798 5.128C14.5463 4.894 14.298 4.75 14.0287 4.75H12ZM0 2.5H6V4H0V2.5Z"
              fill="white"
            />
          </svg>
        ),
      },
      {
        permission: true,
        title: "Warehouse",
        path: "/dashboard/management/warehouse",
        exact: true,
        icon: <FaWarehouse size="1.2rem" color="#FFFFFF" />,
      },
    ],
    warehousemainSection: [
      {
        permission:true,
        title: "Goods in/out",
        path: "/dashboard/warehouse/goodsInout",
        exact: true,
        icon: (
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.2508 4.5495V13.5983L9 18L0.75 13.5983V4.5L9 0L17.2508 4.5495ZM1.5 13.1483L8.625 16.95V9.0225L1.5 5.313V13.1483ZM16.5008 5.35725L9.375 9.024V16.95L16.5008 13.1483V5.35725ZM12.3608 6.64425L5.21025 2.92125L1.9485 4.701L9.0015 8.373L12.3608 6.64425ZM6.00375 2.4885L13.1775 6.2235L16.0515 4.7445L8.99775 0.85575L6.00375 2.4885Z"
              fill="white"
            />
          </svg>
        ),
      },
      {
        permission:true,
        title: "Inventory",
        path: "/production/schedule",
        exact: true,
        icon: (
          <svg
            width="16"
            height="18"
            viewBox="0 0 16 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.25 18H0.5V11.25H4.25V12.5513C4.7285 12.4028 5.2415 12.18 5.57375 12.0345C6.05525 11.8245 6.518 11.7218 6.989 11.7218C7.8995 11.7218 8.64275 12.096 10.2163 12.6255C10.6963 12.786 11.0233 13.1625 11.0975 13.605C11.9405 12.9577 13.2875 11.9122 13.3003 11.9025C13.568 11.6895 13.88 11.577 14.2003 11.577C14.9143 11.577 15.5135 12.1492 15.5135 12.858C15.5135 13.2255 15.3493 13.5907 15.0433 13.875C14.0098 14.835 13.2095 15.5497 12.503 16.1805C12.083 16.5562 11.7035 16.8945 11.342 17.2253C10.7803 17.7405 10.2035 17.9797 9.52625 17.9797C9.2225 17.9797 8.90225 17.931 8.54525 17.8298C6.4655 17.2425 5.18225 17.0527 4.25 17.001V18ZM3.5 12H1.25V17.25H3.5V12ZM4.25 16.248C5.819 16.3365 7.55375 16.77 8.74925 17.1082C9.362 17.2815 10.07 17.3737 10.8358 16.6725C11.795 15.7935 12.8773 14.8628 14.5325 13.3253C15.1505 12.7515 14.399 11.988 13.766 12.4905C13.766 12.4905 11.5453 14.2147 10.9993 14.6227C10.715 14.8365 10.478 15.012 10.1383 15.012C10.058 15.012 9.971 15.0023 9.8765 14.9805C9.38525 14.8673 8.46425 14.6618 7.81025 14.4548C7.379 14.3175 7.532 13.71 8.01125 13.8113C8.3465 13.881 9.20675 14.0737 9.662 14.2013C10.4248 14.412 10.619 13.551 9.9785 13.3373C9.557 13.1948 9.57575 13.1888 8.56175 12.8385C7.586 12.5002 6.90125 12.2738 5.873 12.7215C5.39375 12.93 4.799 13.1835 4.25 13.332V16.248ZM7.0925 1.31325L9.5 0L14.75 2.895V8.65275L9.5 11.454L4.25 8.65275V2.8635L7.088 1.3155L7.0895 1.31175L7.0925 1.31325ZM9.125 5.8245L5 3.6765V8.20275L9.125 10.404V5.8245ZM9.875 5.82525V10.404L14 8.20275V3.70275L9.875 5.82525ZM11.2025 4.299L7.1 2.163L5.4485 3.0645L9.5015 5.17425L11.2025 4.299ZM7.8935 1.73025L12.0192 3.87825L13.5508 3.09L9.49775 0.85575L7.8935 1.73025Z"
              fill="white"
            />
          </svg>
        ),
      },
      {
        permission:true,
        title: "Scan/print barcode",
        path: "/dashboard/warehouse/printscan",
        exact: true,
        icon: (
          <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.332 1.5L15.879 10.0463L10.044 15.879L1.5 7.33575V1.5H7.332ZM7.95375 0H0V7.95675L10.0433 18L18 10.047L7.95375 0ZM5.5605 5.5605C4.97475 6.147 4.026 6.147 3.43875 5.56125C2.853 4.974 2.853 4.02525 3.43875 3.4395C4.02525 2.853 4.97475 2.85375 5.5605 3.43875C6.147 4.026 6.14625 4.974 5.5605 5.5605ZM5.0145 8.19675L8.19675 5.0145L8.727 5.54475L5.54475 8.727L5.0145 8.19675ZM6.075 9.25725L9.25725 6.075L9.52275 6.3405L6.3405 9.52275L6.075 9.25725ZM8.19675 11.379L11.379 8.19675L11.6445 8.46225L8.46225 11.6445L8.19675 11.379ZM6.87075 10.053L10.053 6.87075L10.8488 7.6665L7.6665 10.8488L6.87075 10.053ZM8.99175 12.174L12.174 8.99175L12.7042 9.522L9.522 12.7042L8.99175 12.174ZM10.053 13.2345L13.2345 10.053L13.5 10.3185L10.3185 13.5L10.053 13.2345Z"
              fill="white"
            />
          </svg>
        ),
      },
      {
        permission:true,
        title: "Supplier",
        path: "/dashboard/warehouse/supplier",
        exact: true,
        icon: (
          <svg
            width="18"
            height="14"
            viewBox="0 0 18 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M3.75 6.25V7H9.75V1.75H2.25V1C2.25 0.586 2.586 0.25 3 0.25H10.5C10.914 0.25 11.25 0.586 11.25 1V2.5H14.7502C15.588 2.5 15.9503 2.932 16.2023 3.33025C16.6478 4.03525 17.3542 5.15425 17.784 5.86375C17.925 6.09775 18 6.36625 18 6.64V10C18 10.8167 17.4427 11.5 16.5 11.5H15.75C15.75 12.742 14.742 13.75 13.5 13.75C12.258 13.75 11.25 12.742 11.25 11.5H8.25C8.25 12.742 7.242 13.75 6 13.75C4.758 13.75 3.75 12.742 3.75 11.5H3C2.586 11.5 2.25 11.164 2.25 10.75V6.25H0.75V4.75H6V6.25H3.75ZM6 10.6C6.4965 10.6 6.9 11.0035 6.9 11.5C6.9 11.9965 6.4965 12.4 6 12.4C5.5035 12.4 5.1 11.9965 5.1 11.5C5.1 11.0035 5.5035 10.6 6 10.6ZM13.5 10.6C13.9965 10.6 14.4 11.0035 14.4 11.5C14.4 11.9965 13.9965 12.4 13.5 12.4C13.0035 12.4 12.6 11.9965 12.6 11.5C12.6 11.0035 13.0035 10.6 13.5 10.6ZM11.25 8.5H3.75V10H4.32375C4.7355 9.5395 5.334 9.25 6 9.25C6.666 9.25 7.2645 9.5395 7.67625 10H11.8238C12.2355 9.5395 12.834 9.25 13.5 9.25C14.166 9.25 14.7645 9.5395 15.1763 10H16.5V6.56875L15.2167 4.372C15.0825 4.14175 14.8358 4 14.5695 4H11.25V8.5ZM12 4.75V7H15.75L14.6798 5.128C14.5463 4.894 14.298 4.75 14.0287 4.75H12ZM0 2.5H6V4H0V2.5Z"
              fill="white"
            />
          </svg>
        ),
      },
      {
        permission:true,
        title: "Warehouses",
        path: "/dashboard/warehouse/warehouse-list",
        exact: true,
        icon: <FaWarehouse size="1.2rem" color="#FFFFFF" />,
      },
    ],
  },
  reducers: {
    registerUser(state, action) {
      console.log("slice data", action.payload);
    },
    setshowDropdown(state, action) {
      state.showDropdown = action.payload;
    },
    getRegisterResponse(state, action) {
      console.log(action.payload);
      state.registerMessage = action.payload.message;
      console.log("register message", state.registerMessage);
    },
    logInUser(state, action) {
      console.log(" login user slice data", action.payload);
    },
    getCurrentUser() {
      console.log("get current user call");
    },
    setCurrentUser(state, action) {
      const userData = action.payload;
      state.currentUser = userData;
      console.log("current user", userData);

      console.log("currentUser", state.currentUser);
    },
    setUserPermissions(state, action) {
      state.userPermissions = action.payload;
    },
    setmainSection(state, action) {
      state.mainSection = action.payload;
    },
    setwarehousemainSection(state, action) {
      state.warehousemainSection = action.payload;
    },
  },
});

export const {
  logInUser,
  getCurrentUser,
  setCurrentUser,
  registerUser,
  getRegisterResponse,
  setUserPermissions,
  setmainSection,
  setwarehousemainSection,
  setshowDropdown,
} = userSlice.actions;

export default userSlice.reducer;
